import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { InsidePageWrapper, OutsidePageWrapper } from "@parkschannel/ui";
import { useButtonsAnalytics } from "../../../utils";
import { ParksList } from "../../Parks";
import { ParksFilters } from "./ParksFilters";
import { ParksHeading } from "../../Parks/ParksListSection/ParksHeading";
export const ParksPage = (param)=>{
    let { initialPagination , parksParams  } = param;
    useButtonsAnalytics();
    return /*#__PURE__*/ _jsx(OutsidePageWrapper, {
        children: /*#__PURE__*/ _jsx(InsidePageWrapper, {
            className: "flex flex-col gap-4 md:gap-6 mb-[56px] md:mt-[30px] lg:mt-10",
            children: /*#__PURE__*/ _jsxs("section", {
                id: "parks-videos-section",
                children: [
                    /*#__PURE__*/ _jsx(ParksHeading, {}),
                    /*#__PURE__*/ _jsx(ParksFilters, {
                        pagination: initialPagination,
                        queryParams: parksParams,
                        children: (args)=>/*#__PURE__*/ _jsx(ParksList, {
                                ...args
                            })
                    })
                ]
            })
        })
    });
};
